import React from "react";
import './ToggleButton.css';
import useIsMobile from '../hooks/useIsMobile';

export default function ToggleButton({ isOn, onToggle }) {
  const isMobile = useIsMobile();
  return (
    <div className="toggle-horizontal">
      <span className={isOn ? 'active' : 'inactive'} style={{ fontSize: isMobile ? '11px' : '16px', textAlign: 'center', display: 'inline-block',}}>
        {isMobile ? <>발전<br />그래프</> : '발전 그래프'}
      </span>

      <div className={`toggle-switch ${isOn ? 'on' : 'off'}`} onClick={onToggle}>
        <div className="toggle-circle" />
      </div>

      <span className={!isOn ? 'active' : 'inactive'} style={{ fontSize: isMobile ? '11px' : '16px' }}>
        {isMobile ? <>MPPT<br />정보</> : 'MPPT 정보'}
      </span>
    </div>
  );
}
